import React from "react";
import * as ReactDOM from 'react-dom';
import * as apiKeys from "../../resources/constants/api";
import { formatData } from "../services/geolocation";
import { manageEventViews } from "../services/business";
import { truncate } from "../utils/tools";
import { getCurrentGPSPosition } from '../services/geolocation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import mapboxgl from 'mapbox-gl';
import Breakdown from '../elements/breakdown';
import * as actions from '../../store/pseudo/general';
 
import events from './images/events.jpg';
import users from './images/users.jpg';

mapboxgl.accessToken = apiKeys.MAPBOX_TOKEN;
const JSON2 = { 'type': 'geojson', 'generateId': true, 'data': { 'type': 'FeatureCollection', 'features': [] }};    
const JSONCLUSTER = {
  'type': 'geojson',
  'generateId': true,
  'data': { 'type': 'FeatureCollection', 'features': [] },
  cluster: true,
  clusterMaxZoom: 13,
  clusterRadius: 25,
  clusterProperties: {
    recommended_count: ['+', ['case', ['==', ['get', 'chat_recommended'], true], 1, 0]]
  }
};    
const ICONE_COLORS = {'dataBusinesses': '#ad182f', 'dataDirectory': '#1f79ad'};

class MapBox extends React.Component {
  
  constructor(props) {
    super(props);
    this.today = new Date();
    this.t1 = this.today.setHours(this.today.getHours() + 12);
    this.mapContainer = React.createRef();
    this.data = { 
      zoom : 12, 
      region : null, 
      popUpData: null, 
      dataPoints: null, 
      dataDirectory: null, 
      dataBusinesses: null, 
      dataMock: null, 
      dataChatSuggestions: null,
      longitude: null, 
      styleMap: null, 
      config: null,
      theme: 'light'
    };

    this.state = {
      clusterDetails: null,
      eventMode: true,
      heatmapMode: true,
      categoryPanelOpen: false
    };
    this.breakdownPopup = null;
  }

  componentDidMount() {
    this.loadData(this.props);
    this.createMap();
    window.addEventListener('keydown', this.handleBreakdownEscape, true);
  }

  UNSAFE_componentWillReceiveProps(props){
    const previousTheme = this.data['theme'];
    this.loadData(props);
    if (this.map && previousTheme !== this.data['theme']) {
      this.recreateMapForTheme();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleBreakdownEscape, true);
    if (this.breakdownPopup) {
      this.breakdownPopup.remove();
      this.breakdownPopup = null;
    }
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  //################### LOAD DATA ###################
  //################### LOAD DATA ###################
  loadData = (data)  => {
    if(data){

      // console.log('======> LOAD DATA => ', data);

      this.data['region'] = [parseFloat(data.data['longitude']), parseFloat(data.data['latitude'])];
      this.data['dataPoints'] = data.data['dataPoints'];
      this.data['dataBusinesses'] = data.data['dataBusinesses'];
      this.data['dataDirectory'] = data.data['dataDirectory'];
      this.data['dataMock'] = data.data['dataMock'];
      this.data['dataChatSuggestions'] = data.data['dataChatSuggestions'];
      this.data['longitude'] = data.data['longitude'];
      this.data['styleMap'] = data.data['styleMap'];
      this.data['config'] = data.settings.admin.config;
      this.data['theme'] = (data.data && data.data['theme'] ? data.data['theme'] : 'light');

      //UPDATES DATA LAYER
      if(this.data && this.map){
      
        // console.log('0 UPDATE LAYERS => ', this.data);
        this.updateDataLayers(this.data);
      }

      //UPDATE MAPS CENTER
      if(this.map){
        const mapCenter = [this.map.getCenter().lng, this.map.getCenter().lat];
        const targetCenter = this.data['region'];
        const centerDelta = (
          Math.abs(parseFloat(targetCenter[0]) - parseFloat(mapCenter[0])) +
          Math.abs(parseFloat(targetCenter[1]) - parseFloat(mapCenter[1]))
        );
        if(centerDelta > 0.000002){
          this.map.setCenter(this.data['region']);
        }
      }
    
    }
  }

  getMapStyleByTheme = () => {
    return (this.data['theme'] === 'dark'
      ? 'mapbox://styles/mapbox/dark-v10'
      : 'mapbox://styles/mapbox/light-v10');
  }

  recreateMapForTheme = () => {
    if (!this.map) {
      return;
    }

    const center = this.map.getCenter();
    this.data['region'] = [center.lng, center.lat];
    this.data['zoom'] = this.map.getZoom();
    this.map.remove();
    this.map = null;
    this.createMap();
  }
  
  
  //################### RENDER ###################
  //################### RENDER ###################
  render() {

    return (
      <div ref={this.mapContainer}  className={"BRL map-canvas-shell"} style={this.props.styleMap}>
        <div className={"search_zone_circle"} aria-hidden="true"></div>
        <button
          type="button"
          className="map-fab-locate"
          onClick={() => {this.backtoUser()}}
          aria-label="Center map on my location"
        >
          <FontAwesomeIcon icon={"bullseye"} />
        </button>

        <div className={"filter_container"} >
            <button
              type="button"
              className={"filter z4000 map-filter-btn" + (this.state.eventMode ? " is-active" : "")}
              onClick={() => {
                this.updatingDynamicLayers('dataBusinesses', !this.state.eventMode);
                this.updatingDynamicLayers('dataDirectory', this.state.eventMode);
                this.setState({eventMode: !this.state.eventMode})
              }}>
              <img className={"image_filter"} src={events} alt=""/>
              <div className={"text_filter_container"}>
                <div className={"text_filter"}>{(this.state.eventMode? 'Events': 'Spots')}</div>  
              </div>
            </button>

              <button
                type="button"
                className={"filter z4000 map-filter-btn" + (this.state.heatmapMode ? " is-active" : "")}
                onClick={() => {
                  this.updatingDynamicLayers('dataPoints', !this.state.heatmapMode);
                  this.setState({heatmapMode: !this.state.heatmapMode});
                }}>
                <img className={"image_filter"} src={users} alt=""></img>
                <div className={"text_filter_container"}>
                  <div className={"text_filter"}>{(this.state.heatmapMode? 'Users': 'None')}</div>  
                </div>
              </button>

              {this.props.chatEnabled && (
                <button
                  type="button"
                  className={"filter z4000 map-filter-btn map-ai-chat-btn" + (this.props.chatVisible ? " is-active" : "")}
                  onClick={() => { if (this.props.onToggleChat) { this.props.onToggleChat(); } }}
                  aria-label={(this.props.chatVisible ? 'Hide Gino chat' : 'Open Gino chat')}
                  title="Gino"
                >
                  <img className={"image_filter map-ai-chat-image"} src={users} alt="" />
                  <div className={"text_filter_container"}>
                    <div className={"text_filter"}>AI</div>
                  </div>
                </button>
              )}

              <button
                type="button"
                className={"filter z4000 map-filter-btn spot-filter-toggle-btn" + (this.state.categoryPanelOpen ? " is-active" : "") + (this.props.activeCategories && this.props.activeCategories.size > 0 ? " has-filters" : "")}
                onClick={() => { this.setState({ categoryPanelOpen: !this.state.categoryPanelOpen }); }}
                aria-label={this.state.categoryPanelOpen ? 'Close category filter' : 'Open category filter'}
                title="Filter by category"
              >
                <div className={"text_filter_container spot-filter-icon-container"}>
                  <FontAwesomeIcon icon={"filter"} className={"spot-filter-icon"} />
                </div>
              </button>
        </div>

        {this.state.categoryPanelOpen && Array.isArray(this.props.availableCategories) && (
          <div className={"spot-filter-panel"}>
            <div className={"spot-filter-panel-header"}>Filter</div>
            <div className={"spot-filter-chips"}>
              <button
                type="button"
                className={"spot-filter-chip" + (!this.props.activeCategories || this.props.activeCategories.size === 0 ? " is-active" : "")}
                onClick={() => {
                  if (this.props.onCategoryFilterChange) {
                    this.props.onCategoryFilterChange(new Set());
                  }
                }}
              >All</button>
              {this.props.availableCategories.map(cat => (
                <button
                  key={cat.key}
                  type="button"
                  className={"spot-filter-chip" + (this.props.activeCategories && this.props.activeCategories.has(cat.key) ? " is-active" : "")}
                  onClick={() => {
                    if (this.props.onCategoryFilterChange) {
                      const next = new Set(this.props.activeCategories || []);
                      if (next.has(cat.key)) { next.delete(cat.key); }
                      else { next.add(cat.key); }
                      this.props.onCategoryFilterChange(next);
                    }
                  }}
                >{cat.label}</button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }


  //################### CAPTURE MAP CENTER ###################
  //################### CAPTURE MAP CENTER ###################
  async updateCenter(){
      this.getZoom();
      const center = {lat: this.map.getCenter().lat.toFixed(6), lng: this.map.getCenter().lng.toFixed(6)};
      const temp = {'latitude': truncate(center['lat'],10), 'longitude': truncate(center['lng'],10)};
      this.data.region = [truncate(center['lng'],10), truncate(center['lat'],10)];
      this.props.onChangeCenter(temp, this.data.zoom);
  }

  //################### GO TO USER POSITION ###################
  //################### GO TO USER POSITION ###################
  async backtoUser(){
    this.getZoom();
    const center = await getCurrentGPSPosition();
    this.props.onChangeCenter(center, this.data.zoom, 'search');
  }
  
  //################### CAPTURE CURRENT ZOOM LEVEL ###################
  //################### CAPTURE CURRENT ZOOM LEVEL ###################
  async getZoom(){
    const temp = this.map.getZoom().toFixed(2);
    this.data.zoom = temp;
  }


  //################### CREATE MAP ###################
  //################### CREATE MAP ###################
  createMap = ()  => {

    // CREATE MAP
    this.map = new mapboxgl.Map({
      container: this.mapContainer.current,
      style: this.getMapStyleByTheme(),
      center: this.data.region, zoom: [this.data.zoom], 
      attributionControl: true, 
      dragRotate: false, 
      touchZoomRotate: false, 
      pitchWithRotate: false,
      refreshExpiredTiles: false, 
      minZoom:8, 
      maxZoom:17, 
    });
    // MAP BEHAVIOR ON MOVE
    this.map.on('move', () => { this.updateCenter(); });

    // CREATE LAYER UPON LOADING
    const that = this;
    this.map.on('load', async function () {

      // ############### HEATMAP LAYER ###############
      that.map.addSource( 'dataPoints_source', JSON2);    
      that.map.addLayer({ 
        id: 'dataPoints', 'type': 'heatmap', 'source': 'dataPoints_source', 
        paint: that.data['config'].heatmap,
        layout: { 'visibility': 'visible' }
        });

      //############### ADDING EVENTS LAYER -  CLUSTER ###############
      let name = 'dataBusinesses';
      let name2 = 'dataDirectory';
      that.map.addSource( name + '_source', JSONCLUSTER);    
      that.map.addLayer({
        id: name + '_clusters',
        type: 'circle',
        source: name + '_source',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': [
            'case',
            ['>', ['get', 'recommended_count'], 0],
            '#ba3b53',
            ['step', ['get', 'point_count'], ICONE_COLORS[name], 100, ICONE_COLORS[name], 750, ICONE_COLORS[name]]
          ],
          'circle-radius': ['step', ['get', 'point_count'], 10, 7, 12, 10, 15, 20, 20, 30, 25, 50, 30, 100, 40],
          'circle-stroke-color': [
            'case',
            ['>', ['get', 'recommended_count'], 0],
            'rgba(255, 214, 120, 0.96)',
            'rgba(255, 255, 255, 0.65)'
          ],
          'circle-stroke-width': [
            'case',
            ['>', ['get', 'recommended_count'], 0],
            2.8,
            1.1
          ]
        }
      });
      that.map.addLayer({ id: name + '_cluster-count', type: 'symbol', source: name + '_source', filter: ['has', 'point_count'], layout: { 'text-field': '{point_count_abbreviated}', 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'], 'text-size':12}, paint: {"text-color": "#ffffff"}});    
      that.map.addLayer({
        id: name + '_recommended-glow',
        type: 'circle',
        source: name + '_source',
        filter: ['all', ['!', ['has', 'point_count']], ['==', ['get', 'chat_recommended'], true]],
        paint: {
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 8, 13, 12, 16, 16, 20],
          'circle-color': 'rgba(255, 205, 102, 0.34)',
          'circle-opacity': 0.92,
          'circle-blur': 0.85
        }
      });
      that.map.addLayer({
        id: name + '_recommended-halo',
        type: 'circle',
        source: name + '_source',
        filter: ['all', ['!', ['has', 'point_count']], ['==', ['get', 'chat_recommended'], true]],
        paint: {
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 8, 9, 11, 11, 14, 13, 16, 15],
          'circle-color': 'rgba(255, 214, 120, 0.08)',
          'circle-stroke-color': 'rgba(255, 214, 120, 0.98)',
          'circle-stroke-width': 2.4,
          'circle-blur': 0.25
        }
      });
      that.map.addLayer({
        id: name + '_unclustered-symbol',
        type: 'symbol',
        source: name + '_source',
        filter: ['!', ['has', 'point_count']],
        layout: {
          'icon-image': ['concat' ,['get', 'icon'], '-15'],
          'icon-allow-overlap': true,
          'icon-size': ['case', ['==', ['get', 'chat_recommended'], true], 1.18, 1],
          'text-field': ['get', 'title'],
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': ['case', ['==', ['get', 'chat_recommended'], true], 10.5, 9],
          'text-transform': 'uppercase',
          'text-letter-spacing': 0.05,
          'text-offset': [0, 1.5]
        },
        'paint': {
          "text-color": ['case', ['==', ['get', 'chat_recommended'], true], '#5e3a00', ['get', 'color']],
          'text-halo-color': ['case', ['==', ['get', 'chat_recommended'], true], 'rgba(255, 216, 132, 0.98)', '#fff'],
          'text-halo-width': ['case', ['==', ['get', 'chat_recommended'], true], 3.1, 2],
          'text-halo-blur': ['case', ['==', ['get', 'chat_recommended'], true], 1.15, 0.4]
        }
      });
      // Assuming the map has a layer named 'clusters' and a source 'earthquakes'
      // The following creates a camera animation on cluster feature click
      that.map.on('click', name + '_clusters', (e) => {
        
        const clusterSource = that.map.getSource(name + '_source');
        if (!clusterSource) {
          return;
        }
        const features = that.map.queryRenderedFeatures(e.point, { layers: [name + '_clusters'] });
        if (!features || features.length === 0) {
          return;
        }
        const cluster = features[0].properties;
        const clusterId = cluster.cluster_id;
        if (clusterId === undefined || clusterId === null) {
          return;
        }
        const pointCount = parseInt(cluster.point_count, 10) || 0;

        clusterSource.getClusterExpansionZoom(clusterId, (err, neededZoom) => {
          if (!err) {
            const zoom = Math.min(12, neededZoom);
            const tempCenter = new mapboxgl.LngLat(e.lngLat['lng'], e.lngLat['lat']);
            if (zoom >= 12){
              clusterSource.getClusterLeaves(clusterId, pointCount, 0, (error, leaves) => {
                if (error || !Array.isArray(leaves) || leaves.length === 0) {
                  return;
                }
                that.displayBreakdown(JSON.parse(JSON.stringify(leaves)), tempCenter);
              });
            } else{
              that.map.setZoom(zoom);
              that.map.setCenter(tempCenter);
            }
          }
        });
      });
      //UNCLUSTERED SYMBOLS CLICKS
      that.map.on('click', name + '_unclustered-symbol', (e) => {
        const marker = e.features[0];
        that.displayPopUp(marker);
      });
    


      //############### dataDirectory LAYER ###############
      that.map.addSource( name2 + '_source', JSONCLUSTER);    
      that.map.addLayer({ id: name2 + '_clusters', type: 'circle', source: name2 + '_source', filter: ['has', 'point_count'], paint: {'circle-color': ['step', ['get', 'point_count'], ICONE_COLORS[name2], 100, ICONE_COLORS[name2], 750, ICONE_COLORS[name2]], 'circle-radius': ['step', ['get', 'point_count'], 10, 7, 12, 10, 15, 20, 20, 30, 25, 50, 30, 100, 40]}});
      that.map.addLayer({ id: name2 + '_cluster-count', type: 'symbol', source: name2 + '_source', filter: ['has', 'point_count'], layout: { 'text-field': '{point_count_abbreviated}', 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'], 'text-size':12}, paint: {"text-color": "#ffffff"}});    
      that.map.addLayer({ id: name2 + '_unclustered-symbol', type: 'symbol', source: name2 + '_source', filter: ['!', ['has', 'point_count']], layout: { 'icon-image':  'cafe-15', 'icon-allow-overlap': true, 'text-field': ['get', 'title'], 'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'], 'text-size': 8, 'text-transform': 'uppercase', 'text-letter-spacing': 0.05, 'text-offset': [0, 1.5] }, 'paint': { "text-color": ["get", "color"], 'text-halo-color': '#fff', 'text-halo-width': 2} });

      // Assuming the map has a layer name2d 'clusters' and a source 'earthquakes'
      // The following creates a camera animation on cluster feature click
      that.map.on('click', name2 + '_clusters', (e) => {
        
        const clusterSource = that.map.getSource(name2 + '_source');
        if (!clusterSource) {
          return;
        }
        const features = that.map.queryRenderedFeatures(e.point, { layers: [name2 + '_clusters'] });
        if (!features || features.length === 0) {
          return;
        }
        const cluster = features[0].properties;
        const clusterId = cluster.cluster_id;
        if (clusterId === undefined || clusterId === null) {
          return;
        }
        const pointCount = parseInt(cluster.point_count, 10) || 0;

        clusterSource.getClusterExpansionZoom(clusterId, (err, neededZoom) => {
          if (!err) {
            const zoom = Math.min(12, neededZoom);
            const tempCenter = new mapboxgl.LngLat(e.lngLat['lng'], e.lngLat['lat']);
            if (zoom >= 12){
              clusterSource.getClusterLeaves(clusterId, pointCount, 0, (error, leaves) => {
                if (error || !Array.isArray(leaves) || leaves.length === 0) {
                  return;
                }
                that.displayBreakdown(JSON.parse(JSON.stringify(leaves)), tempCenter);
              });
            } else{
              that.map.setZoom(zoom);
              that.map.setCenter(tempCenter);
            }
          

          }
        });
      });
      //UNCLUSTERED SYMBOLS CLICKS
      that.map.on('click', name2 + '_unclustered-symbol', (e) => {
        const marker = e.features[0];
        that.displayPopUp(marker);
      });


     // ############### MOCK LAYER ###############
     that.map.addSource('dataMock_source', JSON2);    
     that.map.addLayer({ 
       id: 'mock_event', 'type': 'symbol', 'source': 'dataMock_source', 
       layout: { 'icon-image': ['concat' ,['get', 'icon'], '-15'], 'icon-allow-overlap': true, 'text-field': ['get', 'title'], 'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'], 'text-size': 10, 'text-transform': 'uppercase', 'text-letter-spacing': 0.05, 'text-offset': [0, 1.5] }, 
       paint: { "text-color": ["get", "color"], 'text-halo-color': '#fff', 'text-halo-width': 2}
      });
      //UNCLUSTERED SYMBOLS CLICKS
      that.map.on('click', 'mock_event', (e) => {
        const marker = e.features[0];
        that.displayPopUp(marker);
      });

      // ############### CHAT SUGGESTIONS OVERLAY ###############
      that.map.addSource('dataChatSuggestions_source', JSON2);
      that.map.addLayer({
        id: 'dataChatSuggestions_glow',
        type: 'circle',
        source: 'dataChatSuggestions_source',
        paint: {
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 8, 12, 12, 15, 16, 19],
          'circle-color': 'rgba(255, 205, 102, 0.32)',
          'circle-blur': 0.82
        }
      });
      that.map.addLayer({
        id: 'dataChatSuggestions_points',
        type: 'circle',
        source: 'dataChatSuggestions_source',
        paint: {
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 8, 4, 12, 6, 16, 8],
          'circle-color': '#f2bd59',
          'circle-stroke-color': '#ffefcc',
          'circle-stroke-width': 2.1
        }
      });

      // ############### STATS ZONES ###############
      that.map.addSource('stats_source', JSON2);    
      that.map.addLayer({ 
        id: 'stats', 'type': 'fill', 'source': 'stats_source', 
        layout: { }, 
        paint: {'fill-color': 'rgba(173,24,47, 0.4)', 'fill-outline-color': 'rgba(173,24,47, 1)'}
      });

      // Ensure existing data is rendered right after layer bootstrap (important on style/theme switches).
      that.updateDataLayers(that.data);
  
    });

  }

  //################### UPDATE LAYERS DATA ###################
  //################### UPDATE LAYERS DATA ###################
  updateDataLayers = (data) => {

    // console.log('UPDATE LAYERS => EM: ', this.state.eventMode);
    // if(data['dataPoints']){console.log('USERS => ', data['dataPoints']);}
    // if(data['dataBusinesses']){console.log('BUSINESS => ', data['dataBusinesses']);}
    // if(data['dataDirectory']){console.log('DIRECTORY => ', data['dataDirectory']);}

    let tempData;
    const keys = [
      {name: 'dataPoints', type: 'heatmap'},
      {name: 'dataBusinesses', type: 'cluster'},
      {name: 'dataDirectory', type: 'cluster'},
      {name: 'dataMock', type: 'icon'},
      {name: 'dataChatSuggestions', type: 'icon'},
      {name: 'stats', type: 'zone'}
    ];

    for(const key in keys){
      
      // console.log('--- => ', keys[key]);

      if(keys[key]['name'] === 'stats'){
          tempData = { 'type': 'Feature', 'geometry': { 'type': 'Polygon', 'coordinates': [] } }
          if(this.props.area){tempData.geometry.coordinates = this.props.area;}
      }
      else {
          if(data[keys[key]['name']]){
            data[keys[key]['name']]['features'].forEach(el => {  
            let color = '#202';
            
            if(keys[key]['name'] === 'dataBusinesses'){
              let tempDate = new Date(el['properties']['date']);
              tempDate = tempDate.setHours(tempDate.getHours() + 20);
              if(tempDate < this.t1 ){ color = "#ad182f"; }
              el['properties']['color'] = color;
            }
          });
        }
        
        switch(keys[key]['name']){
          case "dataPoints": 
            this.updatingDynamicLayers(keys[key]['name'], this.state.heatmapMode);
          break;
          case "dataBusinesses": 
            this.updatingDynamicLayers(keys[key]['name'], this.state.eventMode);
          break;
          case "dataDirectory":
            this.updatingDynamicLayers(keys[key]['name'], !this.state.eventMode);
          break;
          default: 
            tempData = data[keys[key]['name']]; 
            if(data[keys[key]['name']] && this.map.getSource(keys[key]['name'] + '_source')){
            
              // console.log('SETDATA => ', keys[key], ' => ', tempData)
              this.map.getSource(keys[key]['name'] + '_source').setData(tempData);
            }
          break;
        }
      }
      
    }
  }

  updatingDynamicLayers(name, bVisible){
    let tempData = JSON2['data'];
    switch(bVisible){
      case true: tempData = this.data[name]; break;
      default: break;
    }
    // console.log('---> UPDATING SPECIFIC : ', name, ' ===> ',bVisible, ' => ', tempData, ' => ');
    if(tempData && this.map.getSource(name + '_source')){
      this.map.getSource(name + '_source').setData(tempData);
    }
  }


  //################### GENERATE POPUP ###################
  //################### GENERATE POPUP ###################
  displayPopUp(data){
    let data2 = JSON.parse(JSON.stringify(data));
    if(data2['properties']['images'] && typeof data2['properties']['images'] === 'string'){
      data2['properties']['images'] = JSON.parse(data2.properties.images)
    };
    data2['properties']['promotion'] = (typeof data2['properties']['promotion'] === 'string'? JSON.parse(data2.properties.promotion) : data2.properties.promotion);
    data2['properties']['business'] = (typeof data2['properties']['business'] === 'string'? JSON.parse(data2.properties.business) : data2.properties.business);
    data2['geometry'] =  (typeof data2.properties.position === 'string'? {coordinates: [JSON.parse(data2.properties.position)]} : {coordinates: [data2.properties.position]}); 
    const temp = formatData(this.state.eventMode, data2);
    this.props.onPopUp(temp);
    if(this.state.eventMode){manageEventViews({value:1, id_business: temp['business']['id_business'], id_event: temp['id_event']});}
  }


  displayBreakdown(data, anchorLngLat = null){
    const placeholder = document.createElement('div');
    // console.log('displayBreakdown => ', data);
    ReactDOM.render(<Breakdown data={data} eventMode={this.state.eventMode} selectEvent={(i) => this.displayPopUp(data[i])} />, placeholder);

    if (this.breakdownPopup) {
      this.breakdownPopup.remove();
      this.breakdownPopup = null;
    }

    let lngLat = anchorLngLat;
    if (!lngLat && data && data[0] && data[0].geometry && data[0].geometry.coordinates) {
      lngLat = new mapboxgl.LngLat(data[0].geometry.coordinates[0], data[0].geometry.coordinates[1]);
    }
    if (!lngLat) {
      return;
    }

    this.breakdownPopup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: true,
    })
    .setLngLat(lngLat)
    .setDOMContent(placeholder)
    .addTo(this.map);

    this.breakdownPopup.on('close', () => {
      this.breakdownPopup = null;
    });
  }

  hasBlockingOverlayOpen = () => {
    const carouselOpen = !!document.querySelector('.viewer-carousel-overlay');
    const popupOpen = !!document.querySelector('.popup-modal-modern.show');
    return (carouselOpen || popupOpen);
  }

  handleBreakdownEscape = (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    if (!this.breakdownPopup || !this.breakdownPopup.isOpen || !this.breakdownPopup.isOpen()) {
      return;
    }

    if (this.hasBlockingOverlayOpen()) {
      return;
    }

    event.preventDefault();
    this.breakdownPopup.remove();
    this.breakdownPopup = null;
  }
}

const mapDispatchToProps = dispatch => { 
  return {
    navigate: (direction) => dispatch(actions.navigate(direction))
  }
}

const mapStateToProps = (state) => {
  return { 
    profile: state.profile,
    settings: state.settings
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MapBox);

